import { Mail } from "lucide-react";

const Footer = () => {
  return (
    <footer className="background-theme-color py-4 border-t border-green-100">
      <div className="flex flex-col md:flex-row items-center text-xs text-gray-700 px-6 md:px-12 gap-2">
        {/* Top (Email) */}
        <div className="flex items-center gap-2 md:absolute md:left-12">
          <Mail size={14} className="text-green-700" />
          <span className="font-medium text-gray-800">Inquiry:</span>
          <span className="text-green-700 font-medium">squashhub97@gmail.com</span>
        </div>

        {/* Center (Copyright) */}
        <div className="w-full text-center">
          © {new Date().getFullYear()} SquashHub. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
